// 拓店调研
export default {
    meta: {
        title: '拓店宝-拓店提报',
        url: '/aproval/manage',
        urlName: '拓店调研' // 埋点字段，上报归属的模块
        // eventId: '7090faab-d7d0-49a2-9c99-8847d69397bd'
    }
};
